import { faAngleDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';

//import { actionItems, addToCardItems } from 'data/project-management/actions';
import { Project } from 'data/projects';
import { useContext, useEffect, useState } from 'react';
import { Col, Dropdown, Row, Toast } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import interceptor from 'services/interceptor';
import projectService from 'services/project';
import { formatDistanceToNow } from 'date-fns';
import projectStatusService from 'services/projectstatus';
import { UserContext } from 'contexts/UserContext';

const ActionSection = ({ project }: { project: Project }) => {
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  const [showDeletedToast, setShowDeletedToast] = useState(false);
  const [showEditToast, setShowEditToast] = useState(false);
  const [toastText, setToastText] = useState('');
  const [projectStatusList, setProjectStatusList] = useState<ProjectStatus[]>(
    []
  );

  useEffect(() => {
    interceptor.apiWithAuth
      .get('/projectstatus/get-all')
      .then(response => {
        setProjectStatusList(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const handleDeleteProjectClick = async () => {
    projectService.deleteProject(project).then(data => {
      if (data) {
        setToastText('Deleted project ' + project.title + '  successfully');
        setShowDeletedToast(true);
        navigate('/dashboard/project-management');
      } else {
        console.error('Error:', 'problem deleting project ' + project.title);
      }
    });
  };
  const handleProjectStatusChange = async (newStatusId: string | undefined) => {
    if (newStatusId === undefined) return;
    project.statusId = newStatusId;
    project.status =
      await projectStatusService.getProjectStatusByID(newStatusId);
    project.modifiedBy =
      userContext && userContext.user ? userContext.user.userId : '';
    project.modifiedDate = new Date();

    projectService.editProject(project).then(data => {
      if (data) {
        setToastText('Project status changed successfully');
        setShowEditToast(true);
      } else {
        console.error('Error:', 'problem editing project ' + project.title);
      }
    });
  };

  return (
    <>
      <Toast
        show={showDeletedToast}
        onClose={() => setShowDeletedToast(false)}
        className="align-items-center bg-dark border-0 bottom-0 end-0 light mb-3 me-3 position-fixed text-white z-index-5"
        delay={3000}
        autohide
      >
        <div className="d-flex">
          <Toast.Body className="P-3">
            <span className="fw-black">
              <code className="text-500">{toastText}</code>
            </span>
          </Toast.Body>
        </div>
      </Toast>
      <Toast
        show={showEditToast}
        onClose={() => setShowEditToast(false)}
        className="align-items-center bg-dark border-0 bottom-0 end-0 light mb-3 me-3 position-fixed text-white z-index-5"
        delay={3000}
        autohide
      >
        <div className="d-flex">
          <Toast.Body className="P-3">
            <span className="fw-black">
              <code className="text-500">{toastText}</code>
            </span>
          </Toast.Body>
        </div>
      </Toast>
      <Row className="gx-0 gy-3 border-bottom border-300 px-5 px-lg-6 py-4 p-xl-0">
        <Col xs={12} xl={5} className="border-end-xl border-300">
          <Row className="h-100 align-items-center px-xl-6 justify-content-between justify-content-xl-start">
            <Col xs={7} lg={6}>
              <div>
                <p className="text-700 fs-10 fw-semi-bold mb-0">Created</p>
                <p className="text-1000 fs-9 mb-0">
                  {formatDistanceToNow(project?.createdDate || '', {
                    addSuffix: true
                  })}
                </p>
              </div>
            </Col>
            <Col xs={7} lg={6}>
              <div>
                <p className="text-700 fs-10 fw-semi-bold mb-0">
                  Last modified
                </p>
                {project?.modifiedDate && (
                  <p className="text-1000 fs-9 mb-0">
                    {formatDistanceToNow(project?.modifiedDate || '', {
                      addSuffix: true
                    })}
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} xl={7}>
          <div className="px-xl-6 py-xl-4">
            <div className="d-flex gap-2 justify-content-between align-items-center">
              <div className="d-flex gap-2">
                {String(project.status?.label)}{' '}
              </div>
              <div className="d-flex gap-2">
                <Dropdown align="end">
                  <Dropdown.Toggle
                    className="dropdown-caret-none d-flex align-items-center"
                    variant="soft-info"
                  >
                    Change Status
                    <FontAwesomeIcon icon={faAngleDown} className="ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="py-2">
                    {projectStatusList.map((projectStatus, index) => (
                      <Dropdown.Item
                        key={index}
                        eventKey={projectStatus.statusId}
                        onClick={() =>
                          handleProjectStatusChange(projectStatus.statusId)
                        }
                      >
                        {projectStatus.label}
                      </Dropdown.Item>
                    ))}
                    <Dropdown.Divider />
                    <Dropdown.Item
                      eventKey="4"
                      className="text-danger"
                      onClick={() => handleDeleteProjectClick()}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Button
                  className="btn-icon btn-icon-lg"
                  variant="soft-secondary"
                >
                  <FontAwesomeIcon icon={faCheck} />
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ActionSection;
